module.exports = __webpack_public_path__ + "assets/img/03b.3496e536.jpg";